import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import { getStoredTenantConfig, useAuth } from "@inbim/platform-core";

declare module "vue-router" {
  interface RouteMeta {
    /** Rota pública (sem tenant/Keycloak) — pricing, signup, retorno do Stripe. */
    publica?: boolean;
    title?: string;
  }
}

const routes: RouteRecordRaw[] = [
  { path: "/", redirect: "/planos" },
  {
    path: "/planos",
    name: "planos",
    component: () => import("./pages/PricingPage.vue"),
    meta: { publica: true, title: "Planos" },
  },
  {
    path: "/cadastro",
    name: "cadastro",
    component: () => import("./pages/SignupPage.vue"),
    beforeEnter: (to) => {
      const version = to.query.planVersionId;
      return typeof version === "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(version)
        ? true : { path: "/planos" };
    },
    meta: { publica: true, title: "Criar conta" },
  },
  {
    path: "/billing/sucesso",
    name: "billing-sucesso",
    component: () => import("./pages/BillingSuccessPage.vue"),
    meta: { publica: true, title: "Pagamento confirmado" },
  },
  {
    path: "/billing/cancelado",
    name: "billing-cancelado",
    component: () => import("./pages/BillingCanceledPage.vue"),
    meta: { publica: true, title: "Pagamento cancelado" },
  },
  {
    path: "/entrar",
    name: "entrar",
    component: () => import("./pages/EmailGatePage.vue"),
    meta: { publica: true, title: "Entrar" },
  },
  {
    path: "/conta",
    name: "conta",
    component: () => import("./pages/AccountPage.vue"),
    meta: { publica: false, title: "Minha assinatura" },
  },
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});

router.beforeEach(async (to) => {
  if (to.meta.publica) return true;

  if (!getStoredTenantConfig()) {
    return { path: "/entrar", query: { redirect: to.fullPath } };
  }

  const { initialized, authenticated, login } = useAuth();
  if (initialized.value && !authenticated.value) {
    await login();
    return false;
  }
  return true;
});

router.afterEach((to) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} | inBIM Plus`;
  }
});

export default router;
